<template>
    <div class="wrapper" v-if="detailedSearchResults.results && gridDataLast.length>0">
        <div id="grid-template" v-on:scroll="scrl">
            <div class="table-body-wrapper">
                <table class="table-body gridTable">
                    <thead class="gridHead">
                        <th class="checkboxCol">
                            <i class="icon-line-gritik light-blue-icon-color f-14"></i>
                        </th>
                        <th v-for="column in columnsOf[columnsSelector]" v-show="check(column['prop'])" :class="column['type']">   
                            {{ capitalize(column['name']) }}
                        </th>
                        <th>
                            <div class="dropdown-pull-right">
                                <i class="icon-line-yuvarlakayar f-23 light-white-icon-color" id="colMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                                <div class="dropdown-menu w-auto pull-right h-auto light-blue-border border-radius-20 dropMenu" aria-labelledby="headerMenu">
                                    <ul class="gridColumnFilter">
                                        <li v-for="col in columnsOf[columnsSelector]" v-show="(col['prop']!=='_id'&&col['prop']!=='x'&&col['prop']!=='notes')">
                                            <div class="form-check">
                                                <label>
                                                    <input type="checkbox" :value="col['prop']" :disabled="tableConfigVisible.length <= 1 && tableConfigVisible.indexOf(col['prop']) != -1" v-model="tableConfigVisible">
                                                    <span class="label-text f-14 p-0 m-0">{{col['name']}}</span>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </th>
                    </thead>
                    <tbody class="">
                        <tr v-for="(entry,index) in gridDataLast" :key="index" v-bind:class="{passive:isPassive(entry),trBgColor:trColor(index)}">
                            
                            <td class="checkboxCol p-1">
                                <span v-if="(columnsSelector=='deals'&&!isPassive(entry)) || columnsSelector=='organizations' || columnsSelector=='contacts'">
                                    <i class="icon-line-metin light-blue-icon-color btn-click f-21" @click="(isPassive(entry))?'':goCardPage(entry['_id']['val']['$oid'])"></i>
                                </span>
                            </td>

                            <td v-for="col in columnsOf[columnsSelector]" v-show="check(col['prop'])" class="spanWrapper">

                                <!-- Deals -->
                                <span v-if="entry[col['prop']]['type']==='step'" >
                                    <span v-if="entry[col['prop']]['val']==5">
                                        {{$ml.get('CONCLUDED')}}
                                    </span>
                                    <span v-else>
                                        {{$ml.get('STEP')}} {{entry[col['prop']]['val']}}
                                    </span>
                                </span>
                                
                                <span v-else-if="entry[col['prop']]['type']==='organization'" >
                                    <span v-if="entry[col['prop']]['val']!=undefined && entry[col['prop']]['val']!=null">
                                        <i class="icon-line-firmalar f-22 mx-2 spanOptions float-left" @click="(blockedList.includes(col['prop'])||isPassive(entry))?'':goCardPage(entry[col['prop']]['val']._id.$oid,'orgCard')"></i>
                                       
                                        <span class="hover-color-primary cursor-pointer" @click="(blockedList.includes(col['prop'])||isPassive(entry))?'':goCardPage(entry[col['prop']]['val']._id.$oid,'orgCard')">{{entry[col['prop']]['val']['name']}}</span>
                                    </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='price'" >
                                    <template v-for="(price,index) in entry[col['prop']]['val']" :key="index">
                                        <span v-if="price && price['price']!==null" v-show="!entry[col['prop']]['isEditMode']">({{price['price']}} {{currencySymbol(price['currency'])}}) </span>
                                    </template>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='currency'" >
                                    <span> {{currencySymbol(entry[col['prop']]['val'])}} </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='contactDetail'" >
                                    <span  v-show="!entry[col['prop']]['isEditMode']" v-if="entry[col['prop']]['val']!=null">
                                        <span v-if="entry[col['prop']]['val']['_id']" class="hover-color-primary cursor-pointer" @click="(blockedList.includes(col['prop'])||isPassive(entry))?'':goCardPage(entry[col['prop']]['val']['_id']['$oid'],'contactCard')">  {{entry[col['prop']]['val']['n']}} {{entry[col['prop']]['val']['sn']}}</span>
                                        <span v-else>  {{entry[col['prop']]['val']['n']}} {{entry[col['prop']]['val']['sn']}}</span>
                                    </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='dateObj'" >
                                    <span v-if="entry[col['prop']]['val']!==null && entry[col['prop']]['val']['$date']!==''">
                                       {{ formatDate(new Date(entry[col['prop']]['val']['$date']), "Do MMMM YYYY") }}
                                    </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='user'"  v-show="!entry[col['prop']]['isEditMode']">
                                    <span  v-show="!entry[col['prop']]['isEditMode']" v-if="entry[col['prop']]['val']!=null">  {{entry[col['prop']]['val']['name']}} {{entry[col['prop']]['val']['surName']}}</span>
                                    
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='rate'" >
                                    <span v-if="entry[col['prop']]['val']!==null">
                                        {{getRates(entry[col['prop']]['val'])}}
                                     </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='dealStatus'" >
                                     <span>{{getdealStatus(entry[col['prop']]['val'])}}</span>
                                </span>
                                
                                <!--Deals End-->


                                <!--Companies Start-->
                                
                                <span v-else-if="entry[col['prop']]['type']==='candidate'" >
                                    {{candidateStatus(entry[col['prop']]['val'])}}
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='contacts'" >
                                    <span v-for="contact in entry[col['prop']]['val']" v-show="!entry[col['prop']]['isEditMode']">
                                        ( {{nicename(entry[col['prop']]['val'])}} )
                                    </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='deals'" >
                                    <template v-for="(deal, dealIdx) in entry[col['prop']]['val']" :key="dealIdx">
                                        <span v-if="deal && deal['title']!==null" v-show="!entry[col['prop']]['isEditMode']">{{deal['status']==1?`(${deal['title']})`:''}} </span>
                                    </template>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='country'" >
                                    {{isUndefined(countryList[entry[col['prop']]['val']])}}
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='city'" >
                                    {{cityList[entry[col['prop']]['val']]}}
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='town'" >
                                    {{getTownName(townList[entry['city']['val']],entry[col['prop']]['val'])}}
                                </span>
                                

                                <!--Companies End-->

                                <!--Activities Start-->

                                <span v-else-if="entry[col['prop']]['type']==='isDone'" v-show="!entry[col['prop']]['isEditMode']">
                                    
                                    <div class="form-check">
                                        <label>
                                            <input type="radio" disabled="disabled" :v-model="entry[col['prop']]['val']" :checked="entry[col['prop']]['val']===true?'checked':''">
                                            <span class="label-text f-14 p-0 m-0"></span>
                                        </label>
                                    </div>
                                    <span class="editIcon"><i class="f-14 edit"></i>edit</span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='activityType'" >
                                    <i :class="activityTypeIcon(entry[col['prop']]['val'])" class="light-blue-icon-color f-18"></i> {{activityType(entry[col['prop']]['val'], $ml)}}
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='relContact'" >
                                    <span v-show="!entry[col['prop']]['isEditMode']">
                                        {{nicename(entry[col['prop']]['val'])}}
                                    </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='deal'" >
                                    <span v-show="!entry[col['prop']]['isEditMode']" v-if="entry[col['prop']]['val']!=null && entry[col['prop']]['val']['title']">
                                        <span v-if="entry[col['prop']]['val']._id" class="hover-color-primary cursor-pointer" @click="(blockedList.includes(col['prop'])||isPassive(entry))?'':goCardPage((entry[col['prop']]['val']._id.$oid || entry[col['prop']]['val']._id),'deals')">{{entry[col['prop']]['val']['title']}}</span>
                                        <span v-else>{{entry[col['prop']]['val']['title']}}</span>
                                    </span>
                                </span>

                                <!-- User Start-->

                                <span v-else-if="entry[col['prop']]['type']==='userRole'" >
                                    <span v-show="!entry[col['prop']]['isEditMode']">
                                        {{userRole(entry[col['prop']]['val'], $ml)}}
                                    </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']==='userStatus'" class="userStatus">
                                    <span v-show="!entry[col['prop']]['isEditMode']">
                                        <label class="switch">
                                            <input type="checkbox" v-model="entry['x']['val']" @change="checkactive(entry['_id']['val']['$oid'],entry['activation']['val'])" >
                                            <span class="slider round true"></span>
                                        </label>
                                    </span>
                                </span>
                                

                                <!-- User End-->

                                <!--Activities End-->

                                <!--CustomField-->
                                <span v-else-if="entry[col['prop']]['type']===4" v-show="!entry[col['prop']]['isEditMode']">
                                    <span v-if="entry[col['prop']]['val'].name"> <!--Burası normal gelenler-->
                                        {{entry[col['prop']]['val'].name}}
                                        {{entry[col['prop']]['val'].surName}}
                                    </span>
                                    <span v-else-if="entry[col['prop']]['val'].$oid!=''&&entry[col['prop']]['val'].$oid!=undefined"><!--Burası filtre ile gelenler-->
                                        {{col['users'].find(usr => usr._id['$oid']==entry[col['prop']]['val'].$oid).name}}
                                        {{col['users'].find(usr => usr._id['$oid']==entry[col['prop']]['val'].$oid).surName}}
                                    </span>
                                </span>

                                <span v-else-if="entry[col['prop']]['type']===5 && entry[col['prop']]['val']" v-show="!entry[col['prop']]['isEditMode']">
                                    {{entry[col['prop']]['val']['value']}} {{currencySymbol(entry[col['prop']]['val']['currency'])}}
                                
                                </span>
                                
                                <span v-else-if="entry[col['prop']]['type']===6" >
                                    <span v-if="entry[col['prop']]['val']!==''&&col['options'].find(opt => opt.id==entry[col['prop']]['val'])!==undefined">({{col['options'].find(opt => opt.id==entry[col['prop']]['val']).label}})</span> 
                                </span>

                                <span v-else-if="entry[col['prop']]['type']===7">
                                    <template v-for="(option, optIdx) in entry[col['prop']]['val']" :key="optIdx">
                                        <span v-if="col['options'] && col['options'].find(opt => opt.id==option)!==undefined">({{col['options'].find(opt => opt.id==option).label}})</span>
                                    </template>
                                </span>

                                <!--CustomField End-->

                                <span v-else v-show="!entry[col['prop']]['isEditMode']">
                                    <span v-if="isRowNameColumn(col) && ((columnsSelector=='deals'&&!isPassive(entry)) || columnsSelector=='organizations' || columnsSelector=='contacts')"
                                          class="hover-color-primary cursor-pointer"
                                          @click="(isPassive(entry))?'':goCardPage(entry['_id']['val']['$oid'])">
                                        {{entry[col['prop']]['val']}}
                                    </span>
                                    <span v-else>
                                        {{entry[col['prop']]['val']}}
                                    </span>
                                </span>

                            </td>

                            <td>
                                <span title="Sil" @click="deleteThis(entry,index)" v-if="user.userRoleId==1">
                                    <i class="icon-line-sil iptal btn-click f-21"></i>
                                    
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { mapState,mapGetters,mapActions } from 'vuex'
import axios from 'axios'
import _ from 'underscore'

import { Settings } from 'luxon'
import swal from 'sweetalert'
import { userRole, capitalize, activityType, activityTypeIcon, nicename, isUndefined } from '@/services/resultTableFormatters'



export default {
    name: "resultTable",
    props: {
        /*data: Array,
        columns: Array,
        cellUpdateUrl:String,
        filterGuide:String,
        page:String,
        user:Array,*/
    },
    props:["detailedSearchResults","customFieldArray","user","users"],
    data(){
        return {
            tableArr: [],
            tableConfigVisible:[],
            resultArr: [],
            token:'',
            gridData:[],
            gridDataLast:[],
            columnsSelector:"",
            columnsOf:{
                'deals':[
                    { prop: "_id", name: "Id" },
                    { prop: "x", name: "x", type: "dealsStatus" },
                    { prop: "stageId", name: this.$ml.get('STEP'), type: "step",default:true },
                    { prop: "title", name: this.$ml.get('OPPORTUNITY_NAME'), type: "dealsName",default:true },
                    { prop: "value", name: this.$ml.get('VALUE'), type: "value",default:true },
                    { prop: "orgId", name: this.$ml.get('COMPANY_NAME'), type: "organization",default:true },
                    { prop: "currency", name: this.$ml.get('CURRENCY'), type: "currency" },
                    { prop: "contactId", name: this.$ml.get('CONTACT_PERSONS'), type: "contactDetail" },
                    { prop: "addDate", name: this.$ml.get('CREATION_DATE'), type: "dateObj" },
                    { prop: "cuid", name: this.$ml.get('HOLDER'), type: "user",default:true },
                    { prop: "expectedDate", name: this.$ml.get('ESTIMATED_CLOSING'), type: "dateObj",default:true },
                    { prop: "rate", name: this.$ml.get('DEGREE'), type: "rate"},
                    { prop: "source", name: this.$ml.get('SOURCE'), type: "source" },
                    { prop: "notes", name: this.$ml.get('NOTES'), type: "note" },
                    { prop: "status", name: this.$ml.get('STATUS'), type: "dealStatus",default:true },
                    { prop: "closedDate", name: this.$ml.get('CLOSING_DATE'), type: "dateObj",default:true },
                ],
                'activities':[
                    {prop:'_id',name:"Id",default:true},
                    {prop:'done',name:this.$ml.get('DONE'),type:"isDone",default:true},
                    {prop:'type',name:this.$ml.get('TYPE'),type:"activityType",default:true},
                    {prop:'subject',name:this.$ml.get('SUBJECT'),default:true},
                    {prop:'contactId',name:this.$ml.get('RELATED_PERSON'),type:'relContact'},
                    {prop:'dealId',name:this.$ml.get('RELATED_OPPORTUNITY'),type:"deal"},
                    {prop:'orgId',name:this.$ml.get('RELATED_COMPANY'),type:'organization',default:true},
                    {prop:'assignor',name:this.$ml.get('ASSIGNMENT'),type:'user',default:true},
                    {prop:'assignedTo',name:this.$ml.get('ASSIGNED'),type:'user',default:true},
                    {prop:'dueDate',name:this.$ml.get('PLANNING_HISTORY'),type:"dateObj",default:true},
                    {prop:'doneDate',name:this.$ml.get('CLOSING_DATE'),type:"dateObj",default:true},
                    {prop:'notes',name:this.$ml.get('NOTE')},
                    {prop:'duration',name:this.$ml.get('PLANNED_TIME'),type:"duration"},
                    /*{prop:'totalDeals',name:"Kapanış Tarihi"}*/
                ],
                'organizations':[
                    { prop: "_id", name: "Id" },
                    { prop: "x", name: "x", type: "orgStatus" },
                    { prop: "name", name: this.$ml.get('COMPANY_NAME'), type: "orgName",default:true },
                    { prop: "isCandidate", name: this.$ml.get('TYPE_COMPANY'), type: "candidate",default:true },
                    { prop: "contacts", name: this.$ml.get('CONTACT_PERSONS'), type: "contacts" },
                    { prop: "createdAt", name: this.$ml.get('CREATION_DATE'), type: "dateObj" },
                    { prop: "deals", name: this.$ml.get('OPPORTUNITIES'), type: "deals" },
                    { prop: "emailAddresses", name: this.$ml.get('E_MAILS'),default:true },
                    { prop: "phoneNumbers", name: this.$ml.get('PHONE_NUMBERS'), type: "phones",default:true },
                    { prop: "faxNumbers", name: this.$ml.get('FAKS_NUMBERS'), type: "phones" },
                    { prop: "webAddr", name: this.$ml.get('WEB_SITES') },
                    { prop: "addr", name: this.$ml.get('ADDRESS') },
                    { prop: "country", name: this.$ml.get('COUNTRY'), type: "country" },
                    { prop: "city", name: this.$ml.get('CITY'), type: "city",default:true },
                    { prop: "town", name: this.$ml.get('DISTRICT'), type: "town" },
                    { prop: "postalCode", name: this.$ml.get('POST_CODE') }
                ],
                'contacts': [
                    {prop:'_id',name:"Id"},
                    {prop:'n',name:this.$ml.get('NAME'),type:"contactName", default:true},
                    {prop:'sn',name:this.$ml.get('SURNAME'), default:true},
                    {prop:'tck',name:this.$ml.get('TCK')},
                    {prop:'gsm',name:"Gsm", default:true},
                    {prop:'phone',name:this.$ml.get('PHONE')},
                    {prop:'addr',name:this.$ml.get('ADDRESS')},
                    {prop:'country',name:this.$ml.get('COUNTRY'),type:'country'},
                    {prop:'city',name:this.$ml.get('CITY'),type:'city', default:true},
                    //--{prop:'town',name:"İlçe",type:'town'},
                    {prop:'fax',name:this.$ml.get('FAX')},
                    {prop:'email',name:this.$ml.get('E_MAIL'), default:true},
                    //{prop:'dob',name:"Doğum Tarihi",type:"dateObj"},
                    //{prop:'wed_ann',name:"Evlilik Yıldönümü",type:"dateObj"}
                ],
                'products': [
                    {prop:'_id',name:"Id",default:true},
                    {prop:'name',name:this.$ml.get("PRODUCT_NAME"),default:true},
                    {prop:'code',name:this.$ml.get("CODE"),default:true},
                    {prop:'prices',name:this.$ml.get("PRICE"),type:'price',default:true},
                    //{prop:'quantity',name:this.$ml.get("QUANTITY"),default:true},
                ],
                'users': [
                    {prop:'_id',name:"Id",default:true},
                    {prop: "x", name: "x", type: "userStatus" },
                    {prop:'name',name:this.$ml.get("NAME"),default:true},
                    {prop:'surName',name:this.$ml.get("SURNAME"),default:true},
                    {prop:'email',name:this.$ml.get("E_MAIL"),default:true},
                    {prop:'addDate',name:this.$ml.get("ADDITION_DATE"),type:'dateObj',default:true},
                    {prop:'updateDate',name:this.$ml.get("DATE_OF_UPDATE"),type:'dateObj',default:true},
                    {prop:'userRoleId',name:this.$ml.get("USER_ROLE"),type:'userRole',default:true},
                    {prop:'address',name:this.$ml.get("ADDRESS")},
                    {prop:'city',name:this.$ml.get("CITY"),type:'city',default:true},
                    {prop:'activation',name:this.$ml.get("IS_IT_ACTIVE"),type:'userStatus',default:true},
                ],
                //Daha sonra bakılacak !
                'dealProducts': [
                    {prop:'_id',name:"Id",default:true},
                    {prop:'productId',name:this.$ml.get("PRODUCT"),default:true},
                    {prop:'dealId',name:this.$ml.get("OPORTUNITY"),type:'deal',default:true},
                    {prop:'itemPrice',name:this.$ml.get("PRICE"),default:true},
                    {prop:'quantity',name:this.$ml.get("QUANTITY"),default:true},
                    {prop:'discountPercentage',name:this.$ml.get("DISCOUNT_PERCENTAGE"),default:true},
                    {prop:'x',name:this.$ml.get("NAME"),default:true},
                    {prop:'sum',name:this.$ml.get("TOTAL"),default:true},
                ]
            }
        }
    },
    computed: {
        ...mapState([
            'activityTypeList',
            'baseUrl',
            'isDoneList',
            'countryList',
            'cityList',
            'townList',
            'blockedList'
        ]),
     
    },
    methods: {
        userRole,
        capitalize,
        activityType,
        activityTypeIcon,
        nicename,
        isUndefined,
        formatDate(value, format){
            return this.$moment(value).format(format)
        },
        isRowNameColumn(col) {
            if (!col || !col['prop']) return false
            if (this.columnsSelector === 'deals') {
                return col['prop'] === 'title'
            }
            if (this.columnsSelector === 'organizations') {
                return col['prop'] === 'name'
            }
            if (this.columnsSelector === 'contacts') {
                return col['prop'] === 'n' || col['prop'] === 'sn'
            }
            return false
        },
        ...mapActions([
            'updateCella',
            'updateOrgId',
            'updateContactId',
            'updateDealId',
            'updateLoading'
        ]),


        getToken(){
            axios({
                method:'POST',
                url:'/getToken',
                baseURL: this.baseUrl,
                data: {},
                withCredentials:true
            }).then((res)=>{
                this.token=res.data.token
            })
        },
        checkactive(id,status){
            if(status){
                status="active"
            }else{
                status="passive"
            }
             
            axios({
            method:'POST',
            url:'/changeUserStatus',
            baseURL: this.baseUrl,
            data: {
                token:this.token,
                userId:id,
                status:status
            },
            withCredentials:true
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                         title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc 
                    })
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                         title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        candidateStatus: function (is) {
            
            if(is!==null){
                return is===true ? this.$ml.get('LEAD') : this.$ml.get('CUSTOMER')
            }else{
                return ''
            }
            
        },
        check:function(col){
            var cols = this.tableConfigVisible
            return cols.includes(col) && col!='_id' && col!='notes' && col!='x'
            
        },
        getdealStatus(status){
            var ratestext={ 1:this.$ml.get('OPEN'),2:this.$ml.get('WON'),3:this.$ml.get('NOT_WON') }
            return ratestext[status]
        },
        getRates(rate){
            var rates={ 1:this.$ml.get('NORMAL'),2:this.$ml.get('PRIORITY'),3:this.$ml.get('URGENT') }
            return rates[rate]
        },
        getPriceVal(price){
            var prAray = []
            var prObj = {}
            prObj['price']=price['price']
            prObj['currency']=price['currency']
            prAray.push(prObj)
            return prAray
        },
        goCardPage(id,from){
            if(from=="orgCard"){
                var from = "organizations"
            }else if(from=="contactCard"){
                var from = "contacts"
            }else{
                var from = this.columnsSelector
            }
            if(id!==""){
                if(from=='organizations'){
                    var url = '/organizationCard'
                    localStorage.orgId=id
                    this.updateOrgId(id)
                }else if(from=='contacts'){
                    var url = '/contactCard'
                    localStorage.contactId=id
                    this.updateContactId(id)
                }else if(from=="deals"){
                    var url= "/dealCard"
                    localStorage.dealId=id
                    this.updateDealId(id)
                }

                window.open(url+'/'+id, '_blank');
            }

        },
        isPassiveOrg:function(entry){
            if(entry['x']==undefined){
                return false
            }else{
                if(entry['x']['type']=='orgStatus'&&entry['x']['val']!=true){
                    return true
                }
            }
        },

        // emitToggleEvent() { 
        //     this.$emit('toggle-value', this.tableArr) 

        //     console.log("entry giriş")

            // console.log(entry)

            // console.log(this.gridDataLast)

        //     this.tableArr.push({
        //         conditions: this.gridDataLast,     
        //     });

        //     console.log('entry bitiş')
        // },

        // BUrası önemli
        isPassive:function(entry){
            // console.log("entry giriş")

            // console.log(entry)

            // console.log(this.gridDataLast)

            // this.tableArr.push({
            //     subject: this.gridDataLast,     
            // });

            // const data = JSON.stringify(this.tableArr)
            // window.localStorage.setItem('tableArr', data);

            // console.log(JSON.parse(window.localStorage.getItem('tableArr')))

            // console.log('entry bitiş')
            
            if(entry['x']==undefined){
                return false
            }else{
                if(entry['x']['val']!=true){
                    return true
                }
            }
        },
        trColor(index){
            if(index%2===0){
                return true
            }else{
                return false
            }
        },
        scrl: function(){
            
            const scrollYEmit = document.getElementById('grid-template').scrollTop
            const clientHeightEmit = document.getElementById('grid-template').clientHeight
            const scrollHeightEmit = document.getElementById('grid-template').scrollHeight
            var previousScrollPosition = clientHeightEmit
            var currentScrollPosition = scrollYEmit + clientHeightEmit

            if (currentScrollPosition>previousScrollPosition) {
                this.$emit('scrolled',scrollYEmit,clientHeightEmit,scrollHeightEmit)
            }
            
        },
        getTownName(list,index){
            if(list!==undefined){
                return list[index]
            }
        },
        deleteThis(entry,index){
            var from = this.columnsSelector
            if(from=='products'){
                var url = '/deleteProduct'
                var subj = 'Ürünü silmeyi onaylıyor musunuz ?'
            }else if(from=='activitys'){
                var url = '/deleteActivity'
                var subj = 'Aktiviteyi silmeyi onaylıyor musunuz ?'
            }else if(from=='organizations'){
                var url = '/deleteOrganization'
                var subj = 'Firma silmeyi onaylıyor musunuz ?'
            }else if(from=='contacts'){
                var url = '/deleteContact'
                var subj = 'Kişi silmeyi onaylıyor musunuz ?'
            }else if(from=="deals"){
                var url= "/deleteDeal"
                var subj = 'Fırsatı silmek istiyor musunuz ?'
            }
            swal({
                title: "Dikkat?",
                text: subj,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then((willDelete) => {
                if (willDelete) {
                    if(from=='product'){
                        if(!this.permissions.includes("can_edit_products")){
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                            })
                            return false
                        }
                    }else if(from=='activity'){
                        if(!this.permissions.includes("can_delete_activities")){
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                            })
                            return false
                        }
                    }else if(from=='organization'){
                        if(!this.permissions.includes("can_delete_organizations")){
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                            })
                            return false
                        }
                    }else if(from=='contact'){
                        if(!this.permissions.includes("can_delete_contacts")){
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                            })
                            return false
                        }
                    }else if(from=='opportunities'){
                        if(!this.permissions.includes("can_delete_deals")){
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                            })
                            return false
                        }
                    }

                    axios({
                        method:'POST',
                        url:url,
                        baseURL: this.baseUrl,
                        data: {
                            objId:entry['_id']['val']['$oid']
                        },
                        withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                        if(!res.data.status){
                            this.$router.push('/logout')
                        }
                        if(res.data.status.code==0){
                            this.gridDataLast.splice(index, 1)
                            let text = ""
                            if(from=='product'){
                                text="Ürün silindi!"
                            }else if(from=='activity'){
                                text="Aktivite silindi!"
                            }else if(from=='organization'){
                                text="Firma silindi!"
                            }else if(from=='contact'){
                                text="Kişi silindi!"
                            }else if(from=='opportunities'){
                                text="Fırsat silindi!"
                            }
                            
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: text
                            })
                        }else{
                            this.$notify({ 
                                group: 'foo',
                                type: 'error', 
                                title: this.$ml.get('ERROR'),
                                text: res.data.status.desc
                            })
                        }
                    })
                    
                }
            })
        },
        permissionSet(){
            if(this.permissions.includes("can_edit_products")==false && this.page==="product"){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        },
        getColumnsSelector(val){
            this.columnsSelector = val
            let columns = this.columnsOf[this.columnsSelector];
            for(var col in columns){
                if(columns[col]['default']){
                    this.tableConfigVisible.push(columns[col]['prop'])
                }
            }
        },
        searchControl(firstchild){
            if(firstchild==true){
                 this.gridData=[]
                 this.gridDataLast=[]
                 this.$emit('firstSearchUpdate', false)
            }
            //Add Custom Fields Data
            let columns = this.columnsOf[this.columnsSelector];

            for (var productObjIter in this.detailedSearchResults.results) {
                let obj = {};

                let productObj = this.detailedSearchResults.results[productObjIter];


                for (var column in columns) {
                  var colInProduct = productObj.hasOwnProperty(
                    columns[column]["prop"]
                  );

                  if (colInProduct) {
                    let edObj = {};

                    edObj["val"] = productObj[columns[column]["prop"]];
                    edObj["isEditMode"] = false;
                    edObj["type"] = columns[column]["type"];

                    obj[columns[column]["prop"]] = edObj;
                  } else {
                    let edObj = {};

                    edObj["val"] = null;
                    edObj["isEditMode"] = false;
                    edObj["type"] = columns[column]["type"];
                    if (columns[column]["type"] == "price") {
                      let pricesList = [];
                      let priceObj = {};
                      priceObj["currency"] = null;
                      priceObj["price"] = null;
                      pricesList.push(priceObj);
                      edObj["val"] = pricesList;
                    } else if (columns[column]["type"] == 4) {
                      let oid = {};
                      oid["$oid"] = "";
                      edObj["val"] = {};
                      edObj["val"]["_id"] = oid;
                    } else if (columns[column]["type"] == 5) {
                      let priceObj = {};
                      priceObj["currency"] = "";
                      priceObj["value"] = "";
                      edObj["val"] = priceObj;
                    } else if (columns[column]["type"] == 6) {
                      let selected = "";
                      edObj["val"] = selected;
                    } else if (columns[column]["type"] == 7) {
                      let optionsList = [];
                      edObj["val"] = optionsList;
                    } else if (columns[column]["type"] == "country") {
                      edObj["val"] = "";
                    } else if (columns[column]["type"] == "isCandidate") {
                      edObj["val"] = "";
                    }

                    obj[columns[column]["prop"]] = edObj;
                  }
                }
                this.gridData.push(obj);
                
            }
            this.gridDataLast = this.gridData; 
            //Add Custom Fields Data End

        }
    },
    created(){
        this.getToken();
    },
    watch: {
        customFieldArray(){
            //Custom Fields Title
            for (var item in this.customFieldArray) {

                let obj = {};

                obj["prop"] = this.customFieldArray[item]["_id"]["$oid"];
                obj["name"] = this.customFieldArray[item]["name"];
                obj["type"] = this.customFieldArray[item]["field_type"];
                if (this.customFieldArray[item]["field_type"] == 4) {
                    obj["users"] = this.users;
                } else if (
                    this.customFieldArray[item]["field_type"] == 7 || this.customFieldArray[item]["field_type"] == 6
                ) {
                    obj["options"] = this.customFieldArray[item]["options"];
                }
                // if(this.columnsOf[this.columnsSelector].filter(m => m.prop === obj["prop"]).length===0){
                //      this.columnsOf[this.columnsSelector].push(obj);
                // }
            }
            //Custom Fields Title End

        },

    },
}
</script>
<style scoped>
    @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
    .trBgColor{
        background-color:ghostwhite!important;
    }
    .spanOptions{
        display:none;
        cursor: pointer;
    }
    .spanWrapper:hover .spanOptions{
        display:block;
    }

    .spanWrapper:hover .spanContent{
        display:none;
    }

    .passive{
        color: red!important;
    }

    .editIcon{
        display:none;
    }

    .wrapper{
        width: 100%;
    }

    #grid-template > .table-body-wrapper {
        width: 100%;
    }

    #grid-template {
        width: 100%;
        overflow-x: scroll;
        overflow-y: scroll;
        height: calc(100vh - 138px);
    }

    .vhminus200{
        height: calc(100vh - 181px)!important;
    }
    .vhminus200Organization{
        height: calc(100vh - 223px)!important;
    }
    #grid-template > .table-body-wrapper {
        flex: 1;
    }
    body{
        font-family: Helvetica Neue, Arial, sans-serif;
        font-size: 14px;
        color: #555;
    }

    table {
        border-spacing: 0;
        width: 100%;
    }

    th {
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        font-weight: bold;
    }

    td {
        border-bottom: 1px #66D0FF solid;
    }
    th.checkboxCol{
        border: white!important;
        border-right: 0.5px solid white!important;
        border-top: 0.5px solid white!important;
        border-bottom: 0.5px solid white!important;
    }
    th.checkboxCol,td.checkboxCol{
        width: 30px!important;
        min-width: 30px!important;
    }

    th {
        min-width: 155px;
    /* padding: 10px 20px; */
    }

    th.active {
        font-weight: bolder;
    }

    th:last-child{
        /*float:right;*/
    }

    th.active .arrow {
        opacity: 1;
    }

    th.active .arrow.asc{
        border-bottom: 4px solid #2396ca;
    }

    th.active .arrow.dsc{
        border-top: 4px solid #2396ca;
    }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        margin-left: 5px;
        opacity: 0.66;
    }

    .arrow.asc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid #66D0FF;
    }

    .arrow.dsc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #66D0FF;
    }

    #grid-template {
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        width: 100%;
    }
    .check-scroll{
        overflow-y: scroll;
        height: 90px;
    }
    .max-width-35{
        max-width: 35%!important;
    }
    .gridTable input{
        border: 0px;
        width: 100%;
    }
    .gridTable {
        border-collapse: separate!important;
        -moz-border-radius: 10px;
        -webkit-border-radius: 10px;
        border-spacing: 0;
        width: 100%;
    }

    .gridTable thead th {
        border-right: 0.5px solid white;
        border-top: 0.5px solid white;
        border-bottom: 0.5px solid white;
        border-left-color: white;
        background-color: #3767a0;
        color:white;
        margin-right: 3px;
        font-family: "font-family-bold";
        font-size: 14px;
        padding-left: 6px;
    }

    .gridTable th:first-child {
        border-color: #3767a0;
        border: .5px solid #3767a0;
        font-family: "font-family-bold";
        font-size: 14px;
    }

    .gridTable th:last-child {
        font-family: "font-family-bold";
        font-size: 14px;
        min-width: 45px!important;
    }

    .gridTable tbody tr td {
        height: 34px;
        border-right: 0.5px solid #3767a0;
        border-bottom: 0.5px solid #3767a0;
        font-family: "font-family-regular";
        font-size: 14px;
        padding-left: 6px;
    }

    .gridTable tbody tr td:hover .editIcon{
        /*display: inline-block;*/
    }

    .gridTable tbody tr:hover {
        background-color: #66D1FF30!important;
        /* HOVER */
    }

    .gridTable tbody tr td:hover {
        background-color: white;
        border: 1px solid #66D1FF;
    }

    .gridTable td:first-child {
        border-color: #3767a0;
        border: .5px solid #3767a0;
        font-family: "font-family-regular";
        font-size: 13px;
    }

    .gridTable td:last-child {
        font-family: "font-family-regular";
        font-size: 13px;
        min-width: 45px!important;
        width: 45px!important;
    }


    .gridTable label{
        cursor: pointer;
        color: #666;
        padding: 0px;
        margin: 0px;
    }

    .gridTable input[type="checkbox"], input[type="radio"]{
        position: absolute;
        right: 9000px;
    }

    /*Check box*/
    .gridTable input[type="checkbox"] + .label-text:before{
        content: "\f096";
        font-family: "FontAwesome";
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing:antialiased;
        width: 1em;
        display: inline-block;
        margin-right: 5px;
    }

    .gridTable input[type="checkbox"]:checked + .label-text:before{
        content: "\f14a";
        color: #66D0FF;
        animation: effect 250ms ease-in;
    }

    .gridTable input[type="checkbox"]:disabled + .label-text{
        color: #aaa;
    }

    .gridTable input[type="checkbox"]:disabled + .label-text:before{
        content: "\f0c8";
        color: #ccc;
    }
    @keyframes effect{
        0%{transform: scale(0);}
        25%{transform: scale(1.3);}
        75%{transform: scale(1.4);}
        100%{transform: scale(1);}
    }
    .form-check{
        padding-left: 0.55rem!important;
    }
    .gridColumnFilter{
        list-style: none;
        padding: 10px;
        overflow-y: scroll;
        height: 320px;
    }
    .alphabetic-filter button:first-child {
        width: auto;
        font-family: "font-family-regular";
    }

    /*.filter button{
        color: black;
        border-radius: 20px;
        font-family: "font-family-bold";
        font-size: 14px;
        height: 32px;
        width: 32px;
        background-color: white;
        border: 1px solid #3767a0;
    }

    .filter button:hover {
        background-color: #3767a0;
        border-color: #3767a000;
        font-family: 'font-family-regular';
        font-size: 14px;
        color: white;
    }*/
    *:focus {
        outline: 0px;
    }
    button:focus {
        outline: 0px;
    }

    /*Radio box*/

    .gridTable input[type="radio"] + .label-text:before{
        content: "\f10c";
        font-family: "FontAwesome";
        speak: none;
        font-size: 21px!important;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing:antialiased;
        width: 1em;
        display: inline-block;
        margin-right: 5px;
        color: #66D0FF!important;
    }

    .gridTable input[type="radio"]:checked + .label-text:before{
        content: "\f192";
        color: #66D0FF!important;
        animation: effect 250ms ease-in;
    }

    .gridTable input[type="radio"]:disabled + .label-text{
        color: #66D0FF!important;
    }

    .gridTable input[type="radio"]:disabled + .label-text:before{
        color: #66D0FF!important;
    }

    .autocomplete {
        position: relative;
        width: 130px;
    }

    .autocomplete-results {
        padding: 0;
        margin: 0;
        border: 1px solid #66D0FF80;
        height: 120px;
        overflow: auto;
        position: fixed;
        z-index: 9999;
        width: 44%;
        background-color: white;
        border-radius: 20px;
        height: auto;
    }

    .autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 8px 15px;
        cursor: pointer;
    }

    .autocomplete-result:hover {
        background-color: #4AAE9B;
        color: white;
    }

    .isBlocked{
        cursor: not-allowed;
    }

    .min-w-120{
        min-width: 120px!important;
    }
    .iptal:before{
        color:#f76a6a;  
    }
    
    .gridTable th {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 5;
        background: #fff;
    }

    th.dealStatus,th.value,th.step,th.activityType {
        min-width: 100px !important;
    }

    .userStatus .switch {
    position: relative;
    display: inline-block;
    width: 54px;
    height: 14px;
    }

    .userStatus .switch input { 
    opacity: 0;
    width: 0;
    height: 0;
    }

    .userStatus .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid #3767a050;
    background-color: #fbfbfb;
    -webkit-transition: .4s;
    transition: .4s;
    }

    .userStatus .slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 30px;
    left: -1px;
    bottom: 0px;
    background-color: #3767a050;
    -webkit-transition: .4s;
    transition: .4s;
    }

    .userStatus input:checked + .slider.round:before {
    background-color: #3767a0;
    }

    .userStatus input:focus + .slider {
    box-shadow: 0 0 1px #3767a0;
    }

    .userStatus input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
    }

    /* Rounded sliders */
    .userStatus .slider.round {
    border-radius: 34px;
    }

    .userStatus  .slider.round:before {
    border-radius: 20px;
    }

</style>
